export default function Footer() {
  return (
    <footer className="bg-[#0F172A] border-t border-white/10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <img src="/assets/aegis-logo-dark.webp" alt="Aegis Subsurface LLC logo" className="h-20 w-auto" />
            <p className="mt-5 text-sm text-slate-400 leading-relaxed" data-testid="footer-tagline">
              Coring • Boring • Subsurface Solutions. Serving Greater Houston with dependable, safety-focused field
              services.
            </p>
          </div>
          <div>
            <h3 className="font-heading text-sm font-bold uppercase tracking-wider text-white">Services</h3>
            <ul className="mt-4 space-y-2 text-sm text-slate-400">
              <li><a href="#services" className="hover:text-[#FF5A00] transition-colors" data-testid="footer-link-asphalt">Asphalt Coring Houston</a></li>
              <li><a href="#services" className="hover:text-[#FF5A00] transition-colors" data-testid="footer-link-concrete">Concrete Coring Houston</a></li>
              <li><a href="#services" className="hover:text-[#FF5A00] transition-colors" data-testid="footer-link-geotech">Geotechnical Boring Houston</a></li>
              <li><a href="#services" className="hover:text-[#FF5A00] transition-colors" data-testid="footer-link-soil">Soil Boring Contractor Houston</a></li>
            </ul>
          </div>
          <div>
            <h3 className="font-heading text-sm font-bold uppercase tracking-wider text-white">Contact</h3>
            <ul className="mt-4 space-y-2 text-sm text-slate-400">
              <li><a href="tel:+18326611121" className="hover:text-[#FF5A00] transition-colors" data-testid="footer-phone">(832) 661-1121</a></li>
              <li><a href="mailto:clovis1200@yahoo.com" className="hover:text-[#FF5A00] transition-colors" data-testid="footer-email">clovis1200@yahoo.com</a></li>
              <li data-testid="footer-area">Greater Houston & Surrounding Areas</li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4">
          <p className="text-xs text-slate-500" data-testid="footer-copyright">
            © {new Date().getFullYear()} Aegis Subsurface LLC. All rights reserved.{" "}
            <a href="/login" className="hover:text-[#FF5A00] transition-colors" data-testid="footer-admin-link">Admin</a>
          </p>
          <p className="text-xs text-slate-500 font-mono-tech">Houston, Texas</p>
        </div>
      </div>
    </footer>
  );
}
